import { configureStore } from '@reduxjs/toolkit';
import professionsReducer from './slices/professionsSlice';
import skillsReducer from './slices/skillsSlice';
import responsibilitiesReducer from './slices/responsibilitiesSlice';
import toolsReducer from './slices/toolsSlice';
import departmentsReducer from './slices/departmentsSlice';
import statusesReducer from './slices/statusesSlice';
import prioritiesReducer from './slices/prioritiesSlice';
import languagesReducer from './slices/languagesSlice';

export const store = configureStore({
  reducer: {
    professions: professionsReducer,
    skills: skillsReducer,
    responsibilities: responsibilitiesReducer,
    tools: toolsReducer,
    departments: departmentsReducer,
    statuses: statusesReducer,
    priorities: prioritiesReducer,
    languages: languagesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store; 